import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.242 12.829l-1.414 1.414L10 11.413l-2.828 2.83-1.414-1.414 2.828-2.83-2.828-2.827 1.414-1.414L10 8.586l2.828-2.828 1.414 1.414L11.414 10l2.828 2.829zM10 1.999A8 8 0 1 0 10 18a8 8 0 0 0 0-16z",
  fillRule: "evenodd"
});

var SvgCircleCancelMinor = function SvgCircleCancelMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCircleCancelMinor as S };
